import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Formik } from 'formik';
import { memo } from 'react';
import * as Yup from 'yup';
import { useDispatch } from '../context/DispatchContext';
import { useToaster } from '../context/ToasterContext';
import Button from '../elements/Button';
import Label from '../elements/Label';
import FormikInput from '../elements/formik/FormikInput';
import FormikSelect from '../elements/formik/FormikSelect';
import { MIN_AREA_POINTS, useCheckPointsNumberInWindowArea, } from '../hooks/useCheckPointsNumberInWindowArea';
import { headerLabelStyle } from './Header';
import { HeaderContainer } from './HeaderContainer';
const inputStyle = {
    input: {
        width: '60px',
        textAlign: 'center',
    },
    inputWrapper: { height: '100%' },
};
const LookFor = [
    {
        label: 'Positive',
        value: 'positive',
    },
    {
        label: 'Negative',
        value: 'negative',
    },
    {
        label: 'Both',
        value: 'both',
    },
];
const validationSchema = Yup.object().shape({
    maxNumberOfPeaks: Yup.number().min(0).required(),
    minMaxRatio: Yup.number().min(0).required(),
    noiseFactor: Yup.number().min(0).required(),
});
const INIT_VALUES = {
    maxNumberOfPeaks: 50,
    minMaxRatio: 0.1,
    noiseFactor: 3,
    direction: 'positive',
};
function AutoPeakPickingOptionPanel() {
    const dispatch = useDispatch();
    const pointsNumber = useCheckPointsNumberInWindowArea();
    const toaster = useToaster();
    function handlePeakPicking(values) {
        if (pointsNumber > MIN_AREA_POINTS) {
            dispatch({
                type: 'AUTO_PEAK_PICKING',
                payload: values,
            });
        }
        else {
            toaster.show({
                message: `Auto peak picking only available for area more than ${MIN_AREA_POINTS} points`,
                intent: 'danger',
            });
        }
    }
    return (_jsx(HeaderContainer, { children: _jsx(Formik, { initialValues: INIT_VALUES, onSubmit: handlePeakPicking, validationSchema: validationSchema, children: ({ handleSubmit, isValid }) => (_jsxs(_Fragment, { children: [_jsx(Label, { title: "Direction:", shortTitle: "", style: headerLabelStyle, children: _jsx(FormikSelect, { name: "direction", items: LookFor, style: { width: '85px' } }) }), _jsx(Label, { title: "Max number of peaks:", shortTitle: "Max peaks:", style: headerLabelStyle, children: _jsx(FormikInput, { type: "number", name: "maxNumberOfPeaks", style: inputStyle, min: 0, step: 1 }) }), _jsx(Label, { title: "Noise factor:", shortTitle: "Noise:", style: headerLabelStyle, children: _jsx(FormikInput, { type: "number", name: "noiseFactor", style: inputStyle, min: 0 }) }), _jsx(Label, { title: "Min/max Ratio:", shortTitle: "Ratio:", style: headerLabelStyle, children: _jsx(FormikInput, { type: "number", name: "minMaxRatio", style: inputStyle, step: 0.01, min: 0 }) }), _jsx(Button.Done, { onClick: () => handleSubmit(), style: { margin: '0 10px' }, disabled: !isValid, children: "Apply" })] })) }) }));
}
export default memo(AutoPeakPickingOptionPanel);
